export const projectSetup = {
    developer: "Id Developera",
	name: "Nazwa Projektu",
	website: {
		languages: ['pl'],
		sections: {
			render_360: true,
			visualization_gallery: false,
			tiers: true,
			localization: false,
			similar_apartments: false,
			favorite_apartments: true,
		},
		crm_integration: {
			external_crm: false,
			crm_provider: "deweloper-system",
			internal_queries_handling: true,
			internal_crm: false,
			default_file_name: 'result',
			default_file_types: ['json', 'xml'],
			default_dictionary: {
				object_path_to_units_array: ['root', 'Products', 'Product'],
				unit_id_original: 'Number',
				unit_visibility: {
					key: 'w_IsShow',
					value_visible: '1',
				},
				unit_area_key: 'Area',
				availability_data: {
					key: 'ID_ProductStatus',
					available: '1',
					reserved: '2',
					sold: '3',
				},
				price_data: {
					prices_visibility: {
						key: 'w_IsShowPrice',
						value_visible: '1',
					},
					price_keys_checking_order: ['TotalOfferBrutto', 'TotalBrutto'],
				},
			},
		},
        unit_filters: [
			"area",
			"availability",
			"building",
			"exposition",
			"flags",
			"insolation",
			"price",
			"rooms",
			"supplements",
			"tiers"
		],
		supplementary_areas: [
			"idBalcony",
			"idLoggia",
			"idTerrace",
			"idGarden"
		],
		are_apartment_prices_visible: true,
		are_sold_apartments_visible: true,
		are_sold_apartments_accessible: true,
	},
	site: {
		map_integration: 'osm',
		render_360: false,
		render_360_frames: 72,
		render_360_initial_layer: 0,
		// outlines_buildings: true,
		// outlines_tiers: true,
		// outlines_apartments: true,
		// outlines_render: true,
	},
	buildings: {
		render_360: true,
		render_360_frames: 72,
        render_360_initial_layer: 0,
		// outlines_tiers: true,
		// outlines_apartments: true,
	},
	apartments: {
		render_top: true,
		floorplan_insolation: true,
		render_360: false,
		compartments_versioning: true,
		editing: false,
		floorplan_pdf: false,
		load_with_render_top: true,
		interactive_floorplan: true,
		monochomatic_floorplan: true,
	},
	interiors: {
		render_ai: false,
	},
    pdf_sheets_config: {
		source_key: "id_original",
		source_divider: ".",
		target_divider: "-",
		file_extension: ".pdf",
		file_name_transform: null,
		file_name_prefix: null,
		file_name_suffix: null
	},
	additional_unit_information: {
		supplement_purchases_options: {is_visible: true},
		additional_monetary_obligations: {is_visible: false},
		unit_price_history: {is_visible: true}
	},
	units:{
		query_supplementary_areas: {},
	},
		additional_resources: [
		// {
		// 	name: 'idUnitDetailsSheet',
		// 	name_original: 'Karta lokalu PDF',
		// },
		// {
		// 	name: 'idInformationProspectus',
		// 	name_original: 'Prospekt informacyjny',
		// 	path: '',
		// }
	]
};
